"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ApiManagerAdmin_1 = require("../ApiManagerAdmin");
var ApiConfig_1 = require("../config/ApiConfig");
var ApiTheme = /** @class */ (function (_super) {
    __extends(ApiTheme, _super);
    function ApiTheme() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.GET_NEW_ID = "/api/theme/getNewGroupId";
        _this.GET_GROUP = "/api/theme/getGroup";
        _this.GET_THEMEID = "/api/theme/getTheme";
        _this.UPDATE_GROUP = "/api/theme/updateGroup";
        _this.DELETE_GROUP = "/api/theme/deleteGroup";
        _this.UPDATE_SORT_THEME_GROUP = "/api/theme/sortTheme";
        /**
         * 새로운 theme group 아이디를 생성
         * @param {*} accesstoken
         * @param {*} themeId : themeItem 식볅값
         */
        _this.getNewThemeGroupId = function (accesstoken, themeId) {
            var data = {
                themeId: themeId,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.GET_NEW_ID,
                data: data,
            });
            return config;
        };
        /**
         *theme에 등록된 그룹 리스트 조회
         * @accesstoken
         * @language
         * @themeId
         */
        _this.getThemeGroupList = function (accesstoken, language, themeId) {
            var data = {
                language: language,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: "".concat(_this.GET_THEMEID, "/").concat(themeId),
                data: data,
            });
            return config;
        };
        /**
         * theme group 상세 정보 조회
         * @param {*} accessToken
         * @param {*} language
         * @param {*} themeId
         * @param {*} groupId
         * @returns
         */
        _this.getThemeGroup = function (accesstoken, language, themeId, groupId) {
            var data = {
                language: language,
                themeId: themeId,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: "".concat(_this.GET_GROUP, "/").concat(groupId),
                data: data,
            });
            return config;
        };
        /**
         * theme group 업데이트 api
         * @accessToken
         * @groupId : 1(main)
         * @request : 테마 update Item
         *  language
         *  themeId : themeItem 식볅값
         *  displayName: 사이트 노출용 문구
         *  adminName: 관리자 확인용 문구
         *  matureBit: 성인설정(1: 비성인, 2성인)
         *  comicIds: 해당 그룹에 등록된 작품 ID 배열
         *  order: 그룹별 정렬 값
         */
        _this.updateThemeGroup = function (accesstoken, groupId, request) {
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: "".concat(_this.UPDATE_GROUP, "/").concat(groupId),
                data: request,
            });
            return config;
        };
        /**
         * theme group 삭제
         * @param accesstoken
         * @param language
         * @param themeId
         * @param groupId
         * @returns
         */
        _this.deleteThemeGroup = function (accesstoken, language, themeId, groupId) {
            var data = {
                language: language,
                themeId: themeId,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: "".concat(_this.DELETE_GROUP, "/").concat(groupId),
                data: data,
            });
            return config;
        };
        /**
         * theme 리스트 정렬 api
         * @accessToken
         * @themeId  : 정렬 대상 테마 ID
         * @groupIds : 정렬 순서 별 그룹 ID
         */
        _this.updateThemeGroupSort = function (accesstoken, themeId, groupIds) {
            var data = {
                groupIds: groupIds,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: "".concat(_this.UPDATE_SORT_THEME_GROUP, "/").concat(themeId),
                data: data,
            });
            return config;
        };
        return _this;
    }
    ApiTheme.getInstance = function (initValue) {
        if (!ApiTheme.classInstance) {
            this.classInstance = new ApiTheme(initValue);
        }
        return this.classInstance;
    };
    return ApiTheme;
}(ApiManagerAdmin_1.ApiManager));
exports.default = ApiTheme;
